import { token } from '@/theme';
import { UnderlineCellContainer } from './styled';
import { LONG_DASH } from '../EngineVersionUtils';

export const isEmptyValue = (value): boolean => {
  return value === null || value === undefined || value === '' || value === '-';
};

export const renderValue = (value, color: string = token.colorText, centerAlign: boolean) => {
  if (isEmptyValue(value)) {
    return (
      <UnderlineCellContainer $centerAlign={centerAlign}>
        <span className="disabled-value-span">{LONG_DASH}</span>
      </UnderlineCellContainer>
    );
  }
  return (
    <UnderlineCellContainer $color={color} $centerAlign={centerAlign}>
      <span className="value-span">{value}</span>
    </UnderlineCellContainer>
  );
};
